import { CSSProperties } from "react";

import { getCompanyAvatarColor, getCompanyInitials } from "../../helpers";

import styles from "./CompanyAvatar.module.scss";

interface CompanyAvatarProps {
  id: string;
  name: string;
  avatarUrl?: string | null;
  size?: number;
  borderRadius?: number;
}

const CompanyAvatar = ({
  id,
  name,
  avatarUrl,
  size = 44,
  borderRadius = 12
}: CompanyAvatarProps) => {
  const initials = getCompanyInitials(name);
  const background = getCompanyAvatarColor(id);

  const style: CSSProperties = {
    width: size,
    height: size,
    borderRadius,
    backgroundColor: avatarUrl ? "transparent" : background
  };

  if (avatarUrl) {
    return (
      <div className={styles.avatar} style={style}>
        <img
          src={avatarUrl}
          alt={name}
          className={styles.avatar__image}
          style={{ borderRadius }}
        />
      </div>
    );
  }

  return (
    <div className={styles.avatar} style={style}>
      <span
        className={styles.avatar__initials}
        style={{ fontSize: Math.round(size * 0.36) }}
      >
        {initials}
      </span>
    </div>
  );
};

export default CompanyAvatar;
